export default [{
  name: 'bmpcred',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaBanco: {},
        PessoaEndereco: {}
      },
      Parcela: {},
      PessoaDadosContato: {}
    },
    dadosIniciais: {
      limite: {}
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaEndereco: {}
        },
        Parcela: {},
        PessoaDadosContato: {}
      }
      commit('model', data)

      const value = {
        limite: {}
      }
      commit('dadosIniciais', value)
    }
  },
}]
